<template>
  <div style="display: flex;width: 100%;justify-content: center;" v-if="this.couponDetails.couponId">
    <v-alert
      mode="dark"
      color="warning"
      :value="true"
      :style="{color: '#333', width: $store.getters.getAppWidth+'px', position: 'fixed', 'bottom': 0, 'display': 'flex', padding: 0}"
    >

      <div style="display: flex; justify-content: space-between" class="py-2">

        <v-flex style="text-align: center;">
          <div class="py-1 font-weight-bold px-2"><span>{{ this.couponDetails.prompt }}</span></div>
        </v-flex>
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'ThreeDots',
  data () {
    return {
      coupon: '',
      couponDetails: {
        code: '',
        couponId: '',
        discount: '',
        prompt: ''
      }
    }
  },
  mounted () {
    console.log('CODE', this.$route.query.coupon)
    this.coupon = this.$route.query.coupon
    if (this.coupon) {
      this.getCouponDetails(this.coupon)
    }
  },
  methods: {
    getCouponDetails (coupon) {
      this.$http({
        url: process.env.API_URL + `/ws/userservice/coupons/${coupon}`,
        method: 'GET'
      }).then((data) => {
        this.couponDetails = data.data
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/views/widgets/CouponBanner.vue